// extracted by mini-css-extract-plugin
export default {"link":"XbIpTz5MYwigUj8yF5Bw","tabs":"Eh5ke_HD1o5rE_6SALGW","tabsDesktop":"qTW7rKG1QEtxhaasLqQk","tabPane":"zQ7ppPElOLSaEG7ZdNH9"};